<template>
  <div>
    <h2 class="u-text-center">
      Henter enheter
    </h2>
    <Spinner
      class="c-spinner--page"
    />
  </div>
</template>

<script>
import Spinner from '@/components/Spinner.vue';
export default {
  name: 'PageLoader',
  components: {
    Spinner,
  },
};
</script>